import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {setStore} from "trim-redux";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import List from "@material-ui/core/List/List";
import SubTitle from "../../../components/elements/SubTitle";

class LabelChooser extends React.Component {
    classes = this.props.classes;
    state={
        labels:[],
        label:this.props.initial,
        loading: true,
    }
    componentDidMount(){
        this.setState({
            label:this.props.initial
        })
        this.loadData()
    }
    async loadData(){
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/labels/getAllForChooser`, config)
                .then(response => {
                    this.setState({
                        labels: response.data,
                        loading:false,
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    handleChangeLabel(item){
        let {label} = this.state;
        if(label !== item.id){
            this.setState({
                label:item.id
            });
            this.props.changeLabel(item.id);

        }else{
            this.setState({
                label:null
            });
            this.props.changeLabel(null);

        }

    }
    render(){
        let {labels,loading,label} = this.state;
        let {title} = this.props;
        return(
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <SubTitle align="left">{title}</SubTitle>
                </Grid>
                <Grid item xs={12}>
                    {
                        loading ? null :
                            <List dense style={{maxHeight:240,overflowY:'auto'}}>
                                {
                                    !!labels &&
                                    labels.map((item,index) => (
                                        <ListItem
                                            key={index}
                                            button
                                            dense
                                            onClick={() => this.handleChangeLabel(item)}
                                        >
                                            <ListItemText primary={item.name} />
                                            <ListItemSecondaryAction>
                                                <Checkbox
                                                    edge="end"
                                                    onChange={() => this.handleChangeLabel(item)}
                                                    checked={label === item.id}
                                                />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    ))
                                }

                            </List>

                    }
                </Grid>
            </Grid>
        )

    }
}
export default withStyles(Styles)(LabelChooser);